import { render, staticRenderFns } from "./PatientPaymentNew.vue?vue&type=template&id=08481548&scoped=true&"
import script from "./PatientPaymentNew.vue?vue&type=script&lang=js&"
export * from "./PatientPaymentNew.vue?vue&type=script&lang=js&"
import style0 from "./PatientPaymentNew.vue?vue&type=style&index=0&id=08481548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08481548",
  null
  
)

export default component.exports